import formatGroupedValues from "../utils/formatGroupedValues";

export const NOTES_SORT_OPTIONS = [
  { value: "create_date", label: "Date Created" },
  { value: "note", label: "Note" },
];

export function buildPersonnelNotesFilterChips(
  { createdBy = [], createdFrom, createdTo, relatedTo = [], showDeleted },
  { authorOptions = [], relatedTypeOptions = [] } = {},
) {
  const chips = [];
  if (createdBy.length > 0) {
    const labelFor = (id) => {
      const a = authorOptions.find(
        (o) => String(o.account_id || o.id) === String(id),
      );
      return a ? `${a.first_name || ""} ${a.last_name || ""}`.trim() : String(id);
    };
    chips.push({
      id: "createdBy",
      key: "createdBy",
      fieldId: "notes-created-by",
      label: `Created by: ${formatGroupedValues(createdBy, labelFor, 3)}`,
    });
  }
  if (createdFrom) {
    chips.push({
      id: "createdFrom",
      key: "createdFrom",
      fieldId: "notes-created-from",
      label: `From: ${createdFrom}`,
    });
  }
  if (createdTo) {
    chips.push({
      id: "createdTo",
      key: "createdTo",
      fieldId: "notes-created-to",
      label: `To: ${createdTo}`,
    });
  }
  if (relatedTo.length > 0) {
    const labelFor = (val) => {
      const o = relatedTypeOptions.find(
        (opt) => opt.label === val || String(opt.value) === String(val),
      );
      return o?.label || val;
    };
    chips.push({
      id: "relatedTo",
      key: "relatedTo",
      fieldId: "notes-related-to",
      label: `Related to: ${formatGroupedValues(relatedTo, labelFor, 3)}`,
    });
  }
  if (showDeleted) {
    chips.push({
      id: "deleted",
      key: "showDeleted",
      fieldId: "notes-show-deleted",
      label: "Show Deleted",
    });
  }
  return chips;
}

export function countPersonnelNotesActiveFilters(filters) {
  let n = 0;
  if ((filters.createdBy || []).length > 0) n += 1;
  if (filters.createdFrom) n += 1;
  if (filters.createdTo) n += 1;
  if ((filters.relatedTo || []).length > 0) n += 1;
  if (filters.showDeleted) n += 1;
  return n;
}
